var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPushEngageV2 = function SvgPushEngageV2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.16667V15.8333C15 16.7538 14.2538 17.5 13.3333 17.5H6.66667C5.74619 17.5 5 16.7538 5 15.8333V4.16667C5 3.24619 5.74619 2.5 6.66667 2.5H13.3333C14.2538 2.5 15 3.24619 15 4.16667Z",
    stroke: "var(--Icon-Primary)",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 14.9948C6.66699 14.7614 6.66699 14.6448 6.71241 14.5556C6.75235 14.4772 6.8161 14.4135 6.8945 14.3735C6.98363 14.3281 7.1003 14.3281 7.33366 14.3281H12.667C12.9003 14.3281 13.017 14.3281 13.1062 14.3735C13.1846 14.4135 13.2483 14.4772 13.2882 14.5556C13.3337 14.6448 13.3337 14.7614 13.3337 14.9948V15.1615C13.3337 15.3948 13.3337 15.5115 13.2882 15.6006C13.2483 15.679 13.1846 15.7428 13.1062 15.7827C13.017 15.8281 12.9003 15.8281 12.667 15.8281H7.33366C7.1003 15.8281 6.98363 15.8281 6.8945 15.7827C6.8161 15.7428 6.75235 15.679 6.71241 15.6006C6.66699 15.5115 6.66699 15.3948 6.66699 15.1615V14.9948Z",
    fill: "var(--Icon-Primary)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44434 4.16667H11.111",
    stroke: "var(--Icon-Primary)",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPushEngageV2;